import { prefix } from '@root/utils/Lang';

const modulePrefix = 'module.productCategory';

const translations = {
    'productCategory': 'Termékkategóriák',
    'create.title': 'Új termékkategória',
    'productCategoryCreate': 'Új termékkategória',
    'edit.title': 'Termékkategória szerkesztése',
    'name.title': 'Név',
    'parent_id.title': 'Szülő',
    'url_key.title': 'URL',
    'content.title': 'Tartalom',
    'is_enable.title': 'Engedélyezett?',
    'sort.title': 'Rendezés',
    'date_from.title': 'Dátumtól',
    'date_to.title': 'Dátumig',
    'show_in_menu.title': 'Menüben megjelenik?',
    'keywords.title': 'Meta keywords',
    'keywords.hint': 'A kulcsszavak között használj vesszőt és szóközt!',
    'description.title': 'Meta description',
    'description.hint': 'Maximum 300 karaktert írj!',
    'is_homepage_prohibited.title': 'Főoldalon tiltva?',

};

export default prefix(modulePrefix, translations);



// WEBPACK FOOTER //
// ./src/modules/ProductCategory/lang/hu.ts